export const SUBMISSION_STATUS_SENT = 'Sent';

/**
 * Whether a folder row is a "Sent" one the viewer may open to submit on behalf of
 * its submitter (the 'Ability to view and submit forms with status "Sent"' permission). Decided per row
 * by the backend: a facility-scoped action, admins implicitly.
 */
export const canSubmitOnBehalf = (row) => {
  return row?.status === SUBMISSION_STATUS_SENT && !!row?.can_submit_on_behalf && !!row?.form_initiation_id;
};
